import { faCloudArrowDown, faExternalLink, faInfoCircle, faLink, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import React, { useEffect, useState } from "react";
import {  Col, Form, FormControl, Modal, Row} from "react-bootstrap";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import TooltipButton from "../../../../../components/TooltipButton/TooltipButton";
import AxiosService from "../../../../../utils/AxiosService";
import GuidelineTab from "../StepTwoForm/guidelineTab";
import { setJournalConfig } from "../../../../../store/actions/JournalConfigActions";
import styles from "./StepOneForm.module.scss";


const SteOneForm = ({
	referenceType, setReferenceType, manuscriptId, 
	handelError,language, setLanguage, templateType, 
	journalId, handleSave, setTitle, setAbstract, title, 
	abstract, manuscriptType, setManuscriptType, 
	handleMandatoryCheck, mandatoryFieldSet, studyType, 
	setStudyType, referenceCheck, setReferenceCheck, 
	articleTitle, setArticleTitle, shortTitle, setShortTitle, stepStatus, setStepOneInfo,
	anonymisedPeerReviewCheck, setAnonymisedPeerReviewCheck,
	readPolicyCheck, setReadPolicyCheck, setReadValidationChecklist,
	referenceCitationFormat, setReferenceCitationFormat,
	referenceCitationFormatError, setReferenceCitationFormatError
}) => {
	const apiService = new AxiosService();
	const journalConfig = useSelector(store => store.journalConfig.config) || {};
	const dispatch = useDispatch();
	const [manuscriptTypeOptions, setManuscriptTypeOptions] = useState([])
	const [studyTypesOptions, setStudyTypesOptions] = useState([])
	const [rscPolicies, setRscPolicies] = useState([])
	const [showNote, setShowNote] = useState(false)
	const [showGenericNote, setShowGenericNote] = useState(false)
	const [originalArticle, setOriginalArticle] = useState("")
	const [helpText, setHelpText]=useState([]);
	const [show, setShow] = useState(false);
	const [languageOptions, setLanguageOptions] = useState([])
	const [titleLength, setTitleLength] = useState(-1)
	const [isJournalConfigLoading, setIsJournalConfigLoading] = useState(false)

	const getHelpHext = () => {
		apiService.getHelpText(journalId).then(res=>{
			setHelpText(res.result)
			setLanguageOptions(res.languages)
			if(language==="") {
				setLanguage(res?.languages[0].code)
			}
			if(res.result.length>0){
				setReferenceType(res.result[0].name)
			}
		}).catch(err=>{
			toast.error(err?.response?.data?.message, {autoClose: 3000})
		})
	}
	
	const handleSelect = (e) => {
		const {value} = e.target
		setManuscriptType(value);
		const obj = manuscriptTypeOptions.filter(op => op.name === e.target.value)
		if(!obj[0]?.mainArticle && value !=="" && templateType !== "Generic") {
			setShowNote(true)
		}
		handleMandatoryCheck(e.target.value);
	}

	const handleHelpText = () => {
		setShow(true);
	}

	const handleStudyType = (e) => {
		setStudyType(e.target.value)
	}

	const getManuscriptTypes = () => {
		apiService.getDropdownOptions("manuscript", journalId, manuscriptId).then(res=> {
			if(res.result){
				setManuscriptTypeOptions(res.result);
				res.result.filter(op =>{
					if(op.mainArticle) setOriginalArticle(op.name)
				} )
			}
		})
	}

	const getData =() => {
		apiService.getStepOneDetails(manuscriptId).then(
			res => { 
				const data= res.result;
				setStepOneInfo({...data, templateType: templateType})
				setArticleTitle(data?.manuscriptTitle)
				setManuscriptType(data?.manuscriptType)
				setStudyType(data?.studyType)
				setReferenceType(data?.referenceFormat)
				setLanguage(data?.language)
				if(data?.manuscriptTitle.length > 0) {
					setTitleLength(data.manuscriptTitle.length)
				}
				if(data?.referenceCheck === "yes" || data?.referenceCheck === "no") {
					setReferenceCheck(data?.referenceCheck)
				}
				if(data?.referenceCitationFormat === "superScripts" || data?.referenceCitationFormat === "squareBrackets") {
					setReferenceCitationFormat(data?.referenceCitationFormat)
				}
				if(data?.shortTitle && data?.shortTitle.length > 0) {
					setShortTitle(data.shortTitle)
				}
				if(data?.readPoliciesAndComply) {
					setReadPolicyCheck(true)
				} else {
					setReadPolicyCheck(false)
				}
				if(data?.anonymizedPeerReview) {
					setAnonymisedPeerReviewCheck(true)
				} else {
					setAnonymisedPeerReviewCheck(false)
				}
				if(data?.readingChecklist) {
					setReadValidationChecklist(true)
				} else {
					setReadValidationChecklist(false)
				}
				handleMandatoryCheck(data?.manuscriptType)
			}).catch(e=> {
				toast.error(e?.response?.data?.message, {autoClose: 3000})
			})
	}

	const getRSCPolicies = () => {
		apiService.getDropdownOptions("journalPolicy", journalId, manuscriptId).then(res=> {
			if(res.result){
				setRscPolicies(res.result);
			}
		}).catch((err) => {
			toast.error(err?.response?.data?.message)
		})
	}


	const getStudyTypeOptions= () => {
		apiService.getDropdownOptions("studyTypes", journalId, manuscriptId).then(res=> {
			if(res.result){
				setStudyTypesOptions(res?.result)
			}
		})
	}

	const getJournalConfig = (journalId, manuscriptId, manuscriptType) => {
		setIsJournalConfigLoading(true);
		apiService.getJournalConfig(journalId, manuscriptId, manuscriptType).then((res) => {
			dispatch(setJournalConfig(res.result));
			setIsJournalConfigLoading(false);
		}).catch((err) => {
			toast.error(err?.response?.data?.message || "Failed to load journal configuration");
			setIsJournalConfigLoading(false);
		})
	}
	const handleShowNote = () => {
		setShowNote(false)
	}

	const handleShowGenericNote = () => {
		setShowGenericNote(false)
	}

	useEffect(() => {
		if (templateType === "Generic") {
			setShowGenericNote(true)
		}
	}, [])

	useEffect(()=>{
		getManuscriptTypes()
		getData();
		getStudyTypeOptions()
		getRSCPolicies()
		getHelpHext()	
	},[])

	// Load journal configuration when manuscript type is selected
	useEffect(() => {
		if (manuscriptType && journalId && manuscriptId) {
			getJournalConfig(journalId, manuscriptId, manuscriptType);
		}
	}, [manuscriptType, journalId, manuscriptId])

	// Auto-select reference citation format when only one option is available
	useEffect(() => {
		if(journalConfig?.referenceCitationsFormat?.length === 1) {
			setReferenceCitationFormat(journalConfig?.referenceCitationsFormat[0])
		}
	}, [journalConfig])

	useEffect(() => {
		if (studyTypesOptions.length) {
			let studyTypeCheck = false
			studyTypesOptions.map((item) => {
				if (studyType === item.name) {
					studyTypeCheck = true
				}
			})
			if(!studyTypeCheck) {
				setStudyType("")
			}
		}
	}, [studyTypesOptions])

	return (
			<div className={styles.stepOneStyle}>
				<h5>Article type selection </h5>
				<p className="mb-0">Start the formatting process by selecting the type of manuscript and study type. This will then be validated against the Instructions to Authors for your chosen journal.</p>
				<Form>
					<section className="my-2 mt-4 row">
						<Col md={6}>
							<section className="pb-3">
								<label className="d-flex justify-content-between">
									<span>Article Type <span className="text-danger">*</span></span>
									{/* {templateType !== "Generic" && <button className={styles.noteButton} 
										onClick={(e)=> {
											e.preventDefault()
											setShowNote(true)
										}}
									>
										View Note
									</button>} */}
								</label>
								<select 
									className="form-control" 
									value={manuscriptType} 
									onChange={handleSelect}
									disabled={templateType==="Generic"}
								>
									<option value="">Select article type</option>
									{manuscriptTypeOptions && manuscriptTypeOptions.map(op=> 
									<option key={op.id} value={op.name} >{op.name}</option>
									)
									}
								</select>
							</section>
							<section className="pb-3">
								<label>Manuscript Language <span className="text-danger">*</span></label>
								{languageOptions?.length === 1?
								<FormControl
								value={languageOptions[0]? languageOptions?.[0]?.name: ""}
								name="language"
								readOnly
								/>
								: <select 
									className="form-control"
									name="language" 
									defaultValue={languageOptions?.[0]?.code}
									value={language} 
									onChange={(e)=>setLanguage(e.target.value)}
								>
									{languageOptions && languageOptions.map((value, index)=> 
									<option key={index} value={value.code}>{value.name}</option>
									)
									}
								</select>}
							</section>
						</Col>
						<Col md={6}>
							<section className="pb-3">
								<label>Study Type <span className="text-danger">*</span></label>
								<select 
									className="form-control" 
									value={studyType} 
									onChange={handleStudyType}
								>
									<option value="">Select study type</option>
									{studyTypesOptions && studyTypesOptions.map((value, index)=> 
									<option key={value.id} value={value.name}>{value.name}</option>
									)
									}
								</select>
							</section>
							<section className="pb-3">
								<label className="d-flex justify-content-between align-items-center">
									<div>
										Reference Style
										<TooltipButton key="Reference style" placement="top" tooltipMessage="This journal uses the following reference style. Your references will be converted to this format. To use our reference checking tool please ensure that reference citations are all in the same format (e.g. either all in square brackets or all in superscript, NOT curly brackets).">
											<FontAwesomeIcon icon={faInfoCircle} className={classNames(styles.labelButtonLink,"align-middle pl-1")}/>
										</TooltipButton>
									</div>
									<span className={classNames("textLink cursor-pointer mb-0 float-right")}>
										<a target="_blank" href="https://edu.rsc.org/download?ac=522463">View reference format details</a>
									</span>
									{/* <br />
									Your references will be converted to this format.
									<br/>
									To use our reference checking tool please ensure that reference citations are all in the same format (e.g. either all in square brackets or all in superscript, NOT curly brackets). */}
								</label>
								{ helpText.length === 1 ?
									<>
										<FormControl
											type="text"
											aria-label="referenceType"
											name="referenceType"
											value={ helpText[0]? helpText[0].name: ""}
											className={classNames(styles.customInput)}
											placeholder="Enter file description"
											readOnly
										/>
									</>
								:
									<select  
										value={referenceType} 
										onChange={(e)=> setReferenceType(e.target.value)} 
										name="referenceType"
										className="form-control"
									>
										<option value="">Select reference format</option>
										{helpText.map(help => <option key={help.id}>{help.name}</option>)}
									</select>
								}
							</section>
						</Col>
						{/* Title Fields - Conditional rendering based on journalConfig */}
						{journalConfig?.stepOneFullTitleShortTitle === "yes" ? (
							<>
								{/* Long Title and Short Title fields */}
								<Col md={12} className="mb-3">
									<label htmlFor="manuscrupt-title-step-one">
										Long Title <span className="text-danger">*</span>
										<TooltipButton tooltipMessage="Please enter the full, detailed version of your manuscript title. This is a mandatory field and you won't be able to change this later." placement="top">
											<FontAwesomeIcon icon={faInfoCircle} className={classNames(styles.labelButtonLink, "mx-2 align-middle")} />
										</TooltipButton>
									</label>
									<span className="small text-secondary d-block mb-2">Please ensure the title you enter here is correct and matches the title that will be used in your manuscript in Step Two. <b>When Step One is complete this title cannot be changed.</b></span>
									{stepStatus > 1 && titleLength > 0?
										<>
											<p className="mt-3 border p-2 rounded">{articleTitle}</p>
										</>
									:
										<FormControl
											className="mt-3"
											as="textarea"
											value={articleTitle}
											rows={3}
											placeholder="Please enter your full manuscript title."
											onChange={(e)=> {setArticleTitle(e.target.value)}}
											area-label="Long Title"
											name="articleTitle"
											id="manuscrupt-title-step-one"
										/>
									}
								</Col>
								<Col md={12} className="mb-3">
									<label htmlFor="short-title-step-one">
										Short Title <span className="text-danger">*</span>
										<TooltipButton tooltipMessage="Please enter a concise version of your manuscript title. This is a mandatory field and you won't be able to change this later." placement="top">
											<FontAwesomeIcon icon={faInfoCircle} className={classNames(styles.labelButtonLink, "mx-2 align-middle")} />
										</TooltipButton>
									</label>
									{stepStatus > 1 && shortTitle.length > 0?
										<>
											<p className="mt-3 border p-2 rounded">{shortTitle}</p>
										</>
									:
										<FormControl
											className="mt-3"
											as="textarea"
											value={shortTitle || ""}
											rows={2}
											placeholder="Please enter your short manuscript title."
											onChange={(e)=> {setShortTitle(e.target.value)}}
											area-label="Short Title"
											name="shortTitle"
											id="short-title-step-one"
										/>
									}
								</Col>
							</>
						) : (
							<>
								{/* Single Manuscript Title field */}
								<Col md={12} className="mb-3">
									<label htmlFor="manuscrupt-title-step-one">
										Manuscript Title <span className="text-danger">*</span>
										<TooltipButton tooltipMessage="Please copy and paste in your Manuscript title. This is a mandatory field and you won't be able to change this later." placement="top">
											<FontAwesomeIcon icon={faInfoCircle} className={classNames(styles.labelButtonLink, "mx-2 align-middle")} />
										</TooltipButton>
									</label> <br/>
									<span className="small text-secondary">Please ensure the title you enter here is correct and matches the title that will be used in your manuscript in Step Two. <b>When Step One is complete this title cannot be changed.</b></span>
									{stepStatus > 1 && titleLength > 0?
										<>
											<p className="mt-3 border p-2 rounded">{articleTitle}</p>
										</>
									:
										<FormControl
											className="mt-3"
											as="textarea"
											value={articleTitle}
											rows={3}
											placeholder="Please copy and paste in your Manuscript title."
											onChange={(e)=> {setArticleTitle(e.target.value)}}
											area-label="Manuscript Title"
											name="articleTitle"
											id="manuscrupt-title-step-one"
										/>
									}
								</Col>
							</>
						)}
						<Col md={12} className="mb-3">
							<div className="d-flex flex-column justify-content-between rounded border p-2">
								<fieldset>
									<legend className={styles.regularFont}>Validate my references</legend>
									
									{/* Dynamic text content based on journalConfig */}
									{journalConfig?.referenceCitationsFormat?.length === 1 ? (
										<>
											{journalConfig?.referenceCitationsFormat[0] === "superScripts" ? (
												<div className="d-flex mb-2">
													<input 
														aria-label="Validate reference radio button" 
														className="mr-2" 
														type="radio" 
														name="referenceCheck" 
														value="yes" 
														onChange={(e) => setReferenceCheck(e.target.value)} 
														checked={referenceCheck === "yes"}
													/>
													I would like my references checked and confirm they are in superscript, not square brackets or round brackets/parentheses
												</div>
											) : (
												<div className="d-flex mb-2">
													<input 
														aria-label="Validate reference radio button" 
														className="mr-2" 
														type="radio" 
														name="referenceCheck" 
														value="yes" 
														onChange={(e) => setReferenceCheck(e.target.value)} 
														checked={referenceCheck === "yes"}
													/>
													I would like my references checked and confirm they are in square brackets, not superscript or round brackets/parentheses
												</div>
											)}
										</>
									) : (
										<div className="d-flex flex-column">
											<div className="d-flex mb-2">
												<input 
													aria-label="Validate reference radio button" 
													className="mr-2" 
													type="radio" 
													name="referenceCheck" 
													value="yes" 
													onChange={(e) => setReferenceCheck(e.target.value)} 
													checked={referenceCheck === "yes"}
												/>
												<div className="d-flex flex-column">
													<p className="mb-2 p-0">I would like my references checked and confirm they are in square brackets or superscript, not round brackets/parentheses</p>
													<span className="small text-secondary mb-2">If your references are in superscript and appear mid-sentence please be aware that the reference checker will not detect these and you may prefer to change your reference citations to square brackets throughout</span>
												</div>
											</div>
										</div>
									)}
									
									{/* Conditional Citation Format Dropdown - Only shows when "yes" is selected */}
									{referenceCheck === "yes" && 
										<div className="my-2 ml-4">
											<label className="small d-flex align-items-center">
												Reference Citation Format:
												<span className="text-danger ml-2">*</span>
											</label>
											<select  
												value={journalConfig?.referenceCitationsFormat?.length === 1 ? 
													journalConfig?.referenceCitationsFormat[0] : 
													referenceCitationFormat
												} 
												onChange={(e)=> {
													setReferenceCitationFormat(e.target.value); 
													setReferenceCitationFormatError("")
												}} 
												name="referenceCitationFormat"
												className="form-control"
												disabled={journalConfig?.referenceCitationsFormat?.length === 1}
												aria-label="Select citation format type"
											>
												<option value="">Select reference citation format type</option>
												{journalConfig?.referenceCitationsFormat?.length > 0 ? 
													journalConfig?.referenceCitationsFormat?.map((item) => {
														return (
															<>
																{item === "superScripts" ?
																	<option key="superScripts" value="superScripts">Superscript</option>
																:
																	null
																}
																{item === "squareBrackets" ? 
																	<option key="squareBrackets" value="squareBrackets">Square brackets (please ensure no other text is within square brackets)</option>
																:
																	null
																}
															</>		
														)
													})
												:
													<>
														<option value="superScripts">Superscript</option>
														<option value="squareBrackets">Square brackets (please ensure no other text is within square brackets)</option>
													</>
												}
											</select>
											{referenceCitationFormatError && 
												<span className="text-danger">{referenceCitationFormatError}</span>
											}
										</div>
									}
									
									<div className="d-flex">
										<input 
											aria-label="Don't validate reference radio button" 
											className="mr-2" 
											type="radio" 
											name="referenceCheck" 
											value="no" 
											onChange={(e) => setReferenceCheck(e.target.value)} 
											checked={referenceCheck === "no"}
										/>
										Don't check my references
									</div>
								</fieldset>
							</div>
						</Col>
						<Col md={12} className="mb-3">
							<label className="d-flex align-items-center mt-1">
								Conduct anonymized peer review for manuscript. 
							</label>
							<div className="d-flex flex-column justify-content-between rounded border p-2">
								<div className="d-flex mb-2">
									<input className="mr-2" type="radio" name="anonymisedPeerReviewCheck" value={false} onChange={(e) => setAnonymisedPeerReviewCheck(e.target.value === "true")} checked={anonymisedPeerReviewCheck === false}/>
									My manuscript does not require anonymized peer review
								</div>
								<div className="d-flex">
									<input className="mr-2" type="radio" name="anonymisedPeerReviewCheck" value={true} onChange={(e) => setAnonymisedPeerReviewCheck(e.target.value === "true")} checked={anonymisedPeerReviewCheck === true}/>
									I request anonymized peer review for my manuscript
								</div>
								{anonymisedPeerReviewCheck ? 
									<>
										<span className="mt-2">
											Please refer to the
											<TooltipButton tooltipMessage="Download RSC policy/guidelines"> 
												<a target="_blank" href="https://www.rsc.org/globalassets/05-journals-books-databases/journal-authors-reviewers/our-processes-policies/double-anonymised-author-checklist2.docx">
													<i> Double anonymised author checklist</i>
													<FontAwesomeIcon className="ml-2" icon={faCloudArrowDown}/>
												</a>
											</TooltipButton>
										</span>
									</> 
								: 
									null
								}
							</div>
						</Col>
						<Col md={12} className="mb-3">
							<label className="d-flex justify-content-between align-items-center mt-1">
								Validate compliance by reviewing and confirming our policies
							</label>
							{rscPolicies.length > 0 ?
								<>
									<div className="rounded border p-2">
										<Row>
											{rscPolicies.map((item) => {
												return(
													<>
														<Col md={6} sm={12}>
															<p className="p-0">
																<a target="_blank" href={item.url}>
																	<i dangerouslySetInnerHTML={{__html: item.name}}></i>
																	<FontAwesomeIcon icon={faExternalLink} className="ml-2"/>
																</a>
															</p>
														</Col>
													</>
												)
											})}
										</Row>
										<div className="d-flex flex-column justify-content-between mt-2">
											<div className="d-flex mb-2">
												<input className="mr-2" type="checkbox" name="journalPolicyCheck" value={readPolicyCheck} onChange={(e) => setReadPolicyCheck(e.target.checked ? true : false)} checked={readPolicyCheck === true}/>
												I confirm that I have read the policies and comply with the journal requirements.
											</div>
										</div>
									</div>
								</>
							:	
								<p>No policies found</p>
							}
						</Col>
							

					</section>
					
				</Form> 
				
				<Modal show={false} onHide={()=> handleShowNote()} dialogClassName={classNames("", styles.styleModal)}>
					<Modal.Header  className={classNames("h5 bg-light pb-2")}>
						<span>Note</span><buton onClick={handleShowNote} className="cursor-pointer"><FontAwesomeIcon icon={faXmark} /> </buton>
					</Modal.Header>
					<Modal.Body className="py-0">
					<p className="text-secondary">The formatting tool will apply the template for <strong>{originalArticle}</strong> only and does not format other article types. Please use the template as the basis of your formatting only, and refer to the publisher’s Instructions to Authors for any other formatting that needs to be applied to the document after using this tool.</p>
					</Modal.Body>
				</Modal>

				<Modal show={showGenericNote} onHide={()=> handleShowGenericNote()} dialogClassName={classNames("", styles.styleModal)}>
					<Modal.Header  className={classNames("h5 bg-light pb-2")}>
						<span>Note</span><buton onClick={handleShowGenericNote} className="cursor-pointer"><FontAwesomeIcon icon={faXmark} /> </buton>
					</Modal.Header>
					<Modal.Body className="py-0">
						<p className="text-secondary"><strong>Please note:</strong> our generic template formatting tool will not apply specific journal style. Add your manuscript and AuthorEase will check your figure, table and reference citations. You will be able to upload your figures to be checked, create keywords, add author details and export your document and title page. You can use this document as a basis to add the specific styles of the journal you wish to submit to.</p>
					</Modal.Body>
				</Modal>

				<Modal show={show} onHide={()=> setShow(false)} size="xl" dialogClassName="text-justify">
					<Modal.Header closeButton>
						<Modal.Title>
							<span>Reference format details</span> <br/>
							<span className={classNames(styles.modalHeaderSubtext, "small text-secondary")}>Please note, some journals may use a variation of this formatting. Please check requirements for your chosen journal.</span>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body className={classNames(styles.modalBody, "py-0")} scrollable>
					{helpText.length && <div className=""><GuidelineTab data={helpText}  /></div>}
					</Modal.Body>
				</Modal>
			</div>
	);
}

export default SteOneForm;